export default __webpack_public_path__ + "static/media/n1.bfdd56a0.jpg";